// <s-purchase-type> — keeps the product form's selling_plan in step with the Bundle / Subscribe tabs.
// Bundle disables the frequency dropdown so the order is one-time; Subscribe enables it so the chosen plan is sent.
class SPurchaseType extends HTMLElement {
  #sync = () => {
    const subscribe = this.querySelector("[data-purchase-subscribe]");
    const select = this.querySelector("[data-selling-plan]");
    if (select) select.disabled = !(subscribe && subscribe.checked);
  };

  #onChange = (event) => {
    const target = event.target;
    if (target instanceof HTMLInputElement && target.name === "purchase_type") this.#sync();
  };

  connectedCallback() {
    this.addEventListener("change", this.#onChange);
    this.#sync();
  }

  disconnectedCallback() {
    this.removeEventListener("change", this.#onChange);
  }
}

if (!customElements.get("s-purchase-type")) {
  customElements.define("s-purchase-type", SPurchaseType);
}
